import { TRIGGER_FETCH_MATCH_DETAILS_API_SUCCESS, TRIGGER_CLEAR_MATCH_DETAILS } from 'redux/actionTypes';

const initialState = {};

// export const locale[];

const MatchDetailsReducer = (state = initialState, action) => {
	switch (action.type) {
		case TRIGGER_FETCH_MATCH_DETAILS_API_SUCCESS:
			return {
				...state,
				...action.data,
			};
		case TRIGGER_CLEAR_MATCH_DETAILS:
			return {};
		default:
			return state;
	}
};

export default MatchDetailsReducer;
